import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductContentComponent } from '../product-content/product-content.component';
import { ProductOverviewComponent } from './product-overview.component';

const routes: Routes = [
  {
    path: '',
    component: ProductOverviewComponent,
    children: [
      {
        path: '',
        component: ProductContentComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductOverViewRoutingModule {}
